import {
  getAccessTokenFromStore,
  getIdTokenFromStore,
  isAuthenticated
} from './auth0-pcke';
import { logEvent } from './log-event';
import { readAffectedDepGraph } from './read-affected-dep-graph';
import { readGitBranches } from './read-git-branches';
import { Args, Query, Resolver } from '@nestjs/graphql';
import { Inject } from '@nestjs/common';
import { CONNECT_URL, GRAPHQL_ENDPOINT } from './environment';

@Resolver()
export class QueryResolver {
  constructor(@Inject('telemetry') private readonly telemetry: any) {}

  @Query()
  isAuthenticated() {
    return isAuthenticated();
  }

  @Query()
  connectCredentials() {
    return {
      idToken: getIdTokenFromStore(),
      token: getAccessTokenFromStore(),
      apiUrl: GRAPHQL_ENDPOINT,
      connectUrl: CONNECT_URL
    };
  }

  @Query()
  async depGraph(
    @Args('path') p: string,
    @Args('base') base: string,
    @Args('head') head: string
  ) {
    logEvent(this.telemetry, 'depGraph');
    const json: any = JSON.stringify(await readAffectedDepGraph(p, base, head));
    return { json };
  }

  @Query()
  gitBranches(@Args('path') p: string) {
    return readGitBranches(p);
  }
}
